import request from '@/utils/request';
export function ceretBooksInfo(data) {
  return request({
    url: '/whg-park/api/placeBookInfo/ceretBooksInfo',
    method: 'post',
    data: data
  });
}
export function ceretLongBooksInfo(data) {
  return request({
    url: '/whg-park/api/placeBookInfo/ceretLongBooksInfo',
    method: 'post',
    data: data
  });
}